import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const TournamentParticipantQuerySchema = PaginationRequestSchema.extend({
  tournamentId: z.string().optional(),
  seasonId: z.string().optional(),
  teamId: z.string().optional(),
});
export type TournamentParticipantQueryDTO = z.infer<typeof TournamentParticipantQuerySchema>;

export const TournamentParticipantResponseSchema = z.object({
  id: z.string(),
  tournamentId: z.string(),
  seasonId: z.string().nullable(),
  teamId: z.string().nullable(),
  playerId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  team: z
    .object({
      id: z.string(),
      name: z.string(),
      logo: z.string().nullable(),
    })
    .nullable()
    .optional(),
});
export type TournamentParticipantResponseDTO = z.infer<
  typeof TournamentParticipantResponseSchema
>;

export const TournamentParticipantsPaginatedResponseSchema =
  PaginationResponseSchema(TournamentParticipantResponseSchema);
export type TournamentParticipantsPaginatedResponseDTO = z.infer<
  typeof TournamentParticipantsPaginatedResponseSchema
>;

export const CreateTournamentParticipantRequestSchema = z.object({
  tournamentId: z.string().min(1, "El torneo es requerido"),
  seasonId: z.string().optional(),
  teamId: z.string().optional(),
  playerId: z.string().optional(),
});

export const UpdateTournamentParticipantRequestSchema =
  CreateTournamentParticipantRequestSchema.partial();

export type CreateTournamentParticipantRequestDTO = z.infer<
  typeof CreateTournamentParticipantRequestSchema
>;
export type UpdateTournamentParticipantRequestDTO = z.infer<
  typeof UpdateTournamentParticipantRequestSchema
>;
